import { ExternalLink, CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { SalesOrderDto } from '../types/salesOrder.types';

// FO-SOI-3: visible only when status = Submitted. Mirrors
// CuttingListPostingCard.tsx shape.
interface Props {
  salesOrder: SalesOrderDto;
}

export function SalesOrderPostingCard({ salesOrder }: Props) {
  return (
    <Card className="border-success/30 bg-success/10">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base font-semibold text-success">
          <CheckCircle2 className="h-5 w-5" />
          Posted to NetSuite
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">NetSuite Tran ID</span>
          <span className="font-mono font-semibold">{salesOrder.netSuiteTranId || '—'}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">DOP #</span>
          <span className="font-mono">{salesOrder.salesOrderNumber}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">Posted by</span>
          <span>{salesOrder.postedByName || '—'}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">Posted at</span>
          <span>{salesOrder.postedAt ? new Date(salesOrder.postedAt).toLocaleString() : '—'}</span>
        </div>
        {salesOrder.netSuiteUrl && (
          <a
            href={salesOrder.netSuiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-flex items-center gap-1 text-info hover:underline"
          >
            Open in NetSuite <ExternalLink className="h-3 w-3" />
          </a>
        )}
      </CardContent>
    </Card>
  );
}
